// Dizayn tizimi ko'rgazmasi: barcha asosiy elementlar bir sahifada.
// Yangi komponent qo'shilganda shu yerga ham qo'shiladi.
import { useState } from 'react';
import {
  Badge,
  Button,
  Card,
  Icon,
  SelectField,
  TextAreaField,
  TextField,
  getThemeChoice,
  setThemeChoice,
} from '@onepos/ui';
import type { ThemeChoice } from '@onepos/ui';

export function DesignSystemPage() {
  const [theme, setTheme] = useState<ThemeChoice>(getThemeChoice());

  const changeTheme = (value: string) => {
    const t = value as ThemeChoice;
    setTheme(t);
    setThemeChoice(t);
  };

  return (
    <>
      <header className="cn-page-head">
        <div>
          <h1>Dizayn tizimi</h1>
          <p>ONE POS ranglari, shriftlari va asosiy elementlari</p>
        </div>
        <div style={{ minWidth: 220 }}>
          <SelectField
            label="Tema"
            value={theme}
            onChange={(e) => changeTheme(e.target.value)}
            options={[
              { value: 'system', label: 'Tizimga moslashadi' },
              { value: 'modern', label: 'Zamonaviy' },
              { value: 'dark', label: 'Tungi' },
              { value: 'classic', label: 'Klassik' },
              { value: 'contrast', label: 'Yuqori kontrast' },
            ]}
          />
        </div>
      </header>

      <div className="cn-grid">
        <Card title="Tugmalar">
          <div className="cn-row">
            <Button variant="primary">Asosiy</Button>
            <Button variant="secondary">Ikkinchi darajali</Button>
            <Button variant="mint">
              <Icon name="plus" /> Yangi
            </Button>
            <Button variant="ghost">Oddiy</Button>
            <Button variant="danger">Xavfli</Button>
            <Button variant="secondary" iconOnly aria-label="Yangilash">
              <Icon name="refresh" />
            </Button>
            <Button variant="primary" disabled>
              O&apos;chiq
            </Button>
          </div>
        </Card>

        <Card title="Holat belgilari">
          <div className="cn-row">
            <Badge tone="success">Faol</Badge>
            <Badge tone="info">Sinov · 13 kun</Badge>
            <Badge tone="warning">Imtiyozli davr</Badge>
            <Badge tone="danger">To&apos;xtatilgan</Badge>
            <Badge tone="neutral">Qoralama</Badge>
          </div>
        </Card>

        <Card title="Maydonlar">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <TextField label="Restoran nomi" placeholder="Masalan: Kofe Uyi" />
            <TextField
              label="Ega telefoni (login)"
              defaultValue="+998 93 555 12"
              error="Telefon raqam to'liq emas"
            />
            <TextAreaField label="Ichki eslatma" rows={3} hint="Faqat siz ko'rasiz" />
          </div>
        </Card>

        <Card title="Shriftlar">
          <p style={{ fontSize: 30, fontWeight: 700, margin: '0 0 8px' }}>Sarlavha 30</p>
          <p style={{ fontSize: 18, fontWeight: 700, margin: '0 0 8px' }}>Bo&apos;lim sarlavhasi 18</p>
          <p style={{ margin: '0 0 8px' }}>Asosiy matn 14 — Onest</p>
          <p className="op-num" style={{ margin: '0 0 8px' }}>
            Raqamlar: 1 234 567 so&apos;m
          </p>
          <p className="op-mono" style={{ margin: 0 }}>
            Kod: K7Q-4MP
          </p>
        </Card>
      </div>
    </>
  );
}
